var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: Object.keys(_vm.configSettings).length === 0,
          expression: "Object.keys(configSettings).length === 0",
        },
      ],
      staticClass: "nsw-form-right-block",
      attrs: { "element-loading-text": "Please wait..." },
    },
    [
      _c("h2", [_vm._v(_vm._s(_vm.configSettings["donation-title"]))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nsw-form-box" },
        [
          _c("el-row", { staticClass: "donation-form" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.isLoading,
                    expression: "isLoading",
                  },
                ],
                staticClass: "w-full",
              },
              [
                _vm.configSettings
                  ? [
                      _vm.activeForm !== _vm.formsArray[5]
                        ? _c("FormHeader")
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "keep-alive",
                        [_c(_vm.activeForm, { tag: "component" })],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "disclaimer" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.configSettings["disclaimer"]) +
                            "\n          "
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }